import { AdderDetails, AdderType, SystemDesign } from 'types';

/**
 * Map every valid storage row onto an `AdderDetails` entry. Returns `[]` when
 * there is no battery adder type, or when no row has both `manufacturer` and
 * `model`. All entries share the single `batteryAdderType`; `upsertAdders`
 * group-replaces by type, so other adder types are preserved.
 */
export const buildStorageAdders = (
  storage: SystemDesign['storage'] | undefined,
  batteryAdderType: AdderType | undefined,
): AdderDetails[] => {
  if (!batteryAdderType) return [];
  return (storage ?? [])
    .filter((s): s is NonNullable<typeof s> => Boolean(s?.manufacturer && s?.model))
    .map((s) => ({
      type: batteryAdderType,
      quantity: s.count,
      model: s.model,
      manufacturer: s.manufacturer,
    }));
};
